import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import GlobalLoading from '../components/GlobalLoading';
const EducationDetails = () => {
  const { currentUser, fetchEducationDetails } = useContext(AuthContext);
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const loadTokens = async () => {
      if (!currentUser) {
        setErrorMsg("User not logged in");
        setLoading(false);
        return;
      }

      const result = await fetchEducationDetails();

      if (result?.error) {
        setErrorMsg(result.error);
      } else {
        setTokens(result);
      }

      setLoading(false);
    };

    loadTokens();
  }, [currentUser]);

  return (
    <div className="p-4 md:p-8 max-w-5xl mx-auto">

      {loading ? (
        <GlobalLoading />
      ) : errorMsg ? (
        <p className="text-center text-red-500">{errorMsg}</p>
      ) : tokens.length === 0 ? (
        <p className="text-center text-gray-500">No tokens found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {tokens.map((token, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg shadow p-4 border hover:shadow-lg transition"
            >
              <p><span className="font-medium">Trans ID:</span> {token.trans_id}</p>
              <p><span className="font-medium">Token:</span> {token.token}</p>
              <p className="text-sm text-gray-500 mt-2">
                Created: {new Date(token.createdAt).toLocaleString()}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EducationDetails;
